module.exports = __webpack_public_path__ + "img/qcks_wx_main.80ed252f.jpg";